import { takeLatest, all, takeEvery } from "redux-saga/effects";
import { actionTypes } from "../../Utils/Constants";

import * as authSagas from "./auth";

export function* rootSaga() {
  yield all([
    takeLatest(actionTypes.INIT_LOGIN, authSagas.login),
    takeLatest(actionTypes.LOGOUT_INIT, authSagas.logout),
  ]);
}
